import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useParams } from 'react-router-dom';
import { GuestProvider } from './context/GuestContext';
import './App.css';
import Menu from './pages/Menu/Menu';
import Footer from './components/Footer';
import CategoryList from './pages/Category/CategoryList';
import FoodItemList from './pages/FoodItemList';
import Login from './pages/Login';
import OrderSummary from './components/OrderSummary';
import CheckOut from './pages/CheckOut';
import OrderHistory from './pages/OrderHistory';
import OHSM from './pages/OHSM';
import { Amplify } from 'aws-amplify';
import awsconfig from './aws-exports';
import InvoicePage from "./pages/InvoicePage";

Amplify.configure(awsconfig);

const TOKEN_EXPIRY_TIME = 15 * 60 * 1000; // 15 minutes in milliseconds


// Protected Route Component with redirect to food menu
const ProtectedRoute = ({ children }) => {
  console.log("ProtectedRoute");
  const token = localStorage.getItem('TOKEN');
  const loginTime = localStorage.getItem('loginTime');
  const storedHostelName = localStorage.getItem('hostel_name');
  const storedHostelId = localStorage.getItem('hostel_id');
  const { hostel_name, hostel_id,  locations } = useParams();
  const hostelPath = `/hostel_name/${hostel_name}/hostel_id/${hostel_id}${
    locations ? `/locations/${locations}` : ""
  }`;

  if (!token || !loginTime || new Date().getTime() - loginTime > TOKEN_EXPIRY_TIME) {;
    localStorage.removeItem('TOKEN');
    localStorage.removeItem('loginTime');
    localStorage.removeItem("guestName");
    localStorage.removeItem("guestPhone");
  }

   // Check if hostel name or hostel ID mismatches
   if (storedHostelName !== hostel_name || storedHostelId !== hostel_id) {
    localStorage.removeItem('TOKEN');
    localStorage.removeItem('loginTime');
    // localStorage.clear();
    // return <Navigate to={`${hostelPath}/food-menu`} replace />;
  }

  return children;
};

// Redirect component for handling default routes
const DefaultRedirect = () => {
  const token = localStorage.getItem('TOKEN');
  const hostel_name = localStorage.getItem('hostel_name');
  const hostel_id = localStorage.getItem('hostel_id');
   const locations = localStorage.getItem("locations");


  if (token && hostel_name && hostel_id) {
 return (
   <Navigate
     to={`/hostel_name/${hostel_name}/hostel_id/${hostel_id}${
       locations ? `/locations/${locations}` : ""
     }/food-menu`}
     replace
   />
 );  }
  return <OHSM />;
};

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('TOKEN');
    setIsAuthenticated(!!token);
  }, []);

  // Helper function to handle login state
  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Base route - redirect to OHSM if no hostel info */}
          <Route
            path="/"
            element={(() => {
              const hostel_name = localStorage.getItem("hostel_name");
              const hostel_id = localStorage.getItem("hostel_id");
              const locations = localStorage.getItem("locations");
              return hostel_name && hostel_id ? (
                <Navigate
                  to={`/hostel_name/${hostel_name}/hostel_id/${hostel_id}${
                    locations ? `/locations/${locations}` : ""
                  }/food-menu`}
                  replace
                />
              ) : (
                <OHSM />
              );
            })()}
          />

          {/* Hostel-specific routes */}
          <Route path="hostel_name/:hostel_name/hostel_id/:hostel_id/locations/:locations">
            {/* Protected Routes */}
            {/* <Route path="table-no/:tableNo"> */}
            <Route
              path="food-menu"
              element={
                <ProtectedRoute>
                  <Menu />
                </ProtectedRoute>
              }
            />

            <Route
              path="order-summary"
              element={
                <ProtectedRoute>
                  <OrderSummary />
                </ProtectedRoute>
              }
            />

            <Route
              path="check-out"
              element={
                <ProtectedRoute>
                  <CheckOut />
                </ProtectedRoute>
              }
            />

            <Route
              path="order-history"
              element={
                <ProtectedRoute>
                  <GuestProvider>
                    <OrderHistory />
                  </GuestProvider>
                </ProtectedRoute>
              }
            />
            {/* </Route> */}

            {/* Public Routes */}
            <Route
              path="login"
              element={
                isAuthenticated ? (
                  <Navigate to="../food-menu" replace />
                ) : (
                  <Login onLoginSuccess={handleLogin} />
                )
              }
            />

            <Route
              path="categories/fnb"
              element={
                <ProtectedRoute>
                  <CategoryList type="fnb" />
                </ProtectedRoute>
              }
            />
            <Route
              path="categories/exp"
              element={
                <ProtectedRoute>
                  <CategoryList type="exp" />
                </ProtectedRoute>
              }
            />
            <Route
              path="food-item"
              element={
                <ProtectedRoute>
                  <FoodItemList />
                </ProtectedRoute>
              }
            />
          </Route>

          {/* Catch-all route
          <Route path="*" element={<OHSM />} /> */}

          {/* Catch-all route - redirects to food menu if authenticated, otherwise OHSM */}
                    <Route path="/invoice/:guestId" element={<InvoicePage/>}/>
          <Route path="*" element={<DefaultRedirect />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;